import React, {Component} from 'react'
import FJButtonNormalIcon from "./FJButtonNormalIcon";
import {connect} from "react-redux";

class FJButtonBackward extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let {
      currentTime,
      duration,
      icon,
      onMouseDown,
      className,
    } = this.props;

    let disabled = duration === 0 || currentTime === 0;

    return (
        <FJButtonNormalIcon disabled={disabled} icon={icon} className={className} onMouseDown={onMouseDown} />
    );
  }
}

const mapStateToProps = function (state) {
  return {
    currentTime: state.timeline.currentTime,
    duration: state.timeline.duration,
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
  }
};

export default connect(mapStateToProps, mapDispatchToProps, null, {forwardRef: true})(FJButtonBackward);
